<div class="form-style gt-flex-dir-col no-scroll">
    <div [style.width]="'100%'">
        <dx-form class="form-style-container grid-over-pad" colCount="3" [formData]="siteData" [style.width]="'100%'"
            [readOnly]="!editMode">
            <dxi-item itemType="group" colSpan="3" colCount="3">
                <dxi-item colSpan="1" dataField="projectName" [editorOptions]="{maxLength: 255}">
                    <dxo-label i18n-text="@@sitename" text="Site Name"></dxo-label>
                </dxi-item>
                <dxi-item colSpan="1" dataField="projectNumber" [editorOptions]="{maxLength: 50}">
                    <dxo-label i18n-text="@@siteNr" text="Site Nr."></dxo-label>
                </dxi-item>
                <dxi-item colSpan="1" dataField="projectPipelineNumber" [editorOptions]="{maxLength: 50}">
                    <dxo-label i18n-text="@@sitePipelineNumber" text="Site Pipeline Number">
                    </dxo-label>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>

    <div class="content">
        <div class="col col-left gt-margin-medium-right">
            <div *ngIf="projects != undefined" class="gt-grid gap-20 col-3 collapse-sm-1 projects-container">
                <!-- gt-flex-dir-row projects-container -->
                <div *ngFor="let project of projects"> <!-- class="wrap-overflow" -->
                    <div class="card grid-project-card" (click)="goToProject(project.id)">

                        <!-- <div class="card-title grid-project-card-title">
                            <h3> {{project.nr}} | {{project.name}} </h3>
                        </div> -->

                        <div *ngIf="editMode!=true" class="card-title grid-project-card-title">
                            <h3> {{project.nr}} | {{project.name}} </h3>
                        </div>

                        <div *ngIf="editMode==true && userCanDeleteProject!=true"
                            class="card-title grid-project-card-title">
                            <h3> {{project.nr}} | {{project.name}} </h3>
                        </div>

                        <div *ngIf="editMode==true && userCanDeleteProject==true"
                            class="card-title grid-project-card-title delete-project-container">
                            <h3 class="delete-project-heading"> {{project.nr}} | {{project.name}} </h3>
                            <button class="delete-project-button" (click)="initDeleteProject(project,$event)"> <i
                                    class="dx-icon-remove"></i> </button>
                        </div>

                        <div class="card-image">
                            <img *ngIf="project.imageVersion != null" [src]="project.id | projectImage: project.imageVersion | async" alt="" height="200px" />
                            <img *ngIf="project.imageVersion == null" height="200px"
                                src="../../../../assets/images/backgrounds/markus-spiske-d7FbDJkJSFw-unsplash.jpeg"
                                alt="" />
                        </div>
                        <div class="card-content">
                            <div> {{phase}} {{project.phase}} </div>
                            <div> {{typeText}} {{project.type}} </div>
                            <div> {{sizeOfArea}} {{project.sizeArea}} </div>
                            <div> {{sizeLabel}} {{project.sizeOutput}} {{project.sizeUnit ?? ''}} </div>
                            <!-- <div class="delete-project-container">
                                <dx-button *ngIf="editMode && userIsAdmin" icon="remove" class="gt-button gt-warning delete-project-button" (onClick)="initDeleteProject(project,$event)" i18n-text text="DELETE Project"></dx-button>
                            </div> -->
                        </div>
                    </div>

                </div>
                <div *ngIf="userCanEdit===true" class="card card-new-project">
                    <div i18n="@@addNewProject">Add new Project</div>
                    <div class="card-new-project-inner">
                        <dx-button class="new-project-button" icon="plus" (onClick)="initNewProject($event)"></dx-button>
                    </div>
                </div>
            </div>

            <!--div style="margin-left:20px;width:100%;height:10%">
                <dx-form formData="" width="100%" class="gt-flex">
                    <dxi-item itemType="group" i18n-caption="@@note" caption="Notiz">
                        <dxi-item>
                            <dxo-label i18n-text [visible]="false" text=""></dxo-label>
                            <dx-text-area [(value)]="siteData.comments" [readOnly]="!editMode" height="100px">
                            </dx-text-area>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </div-->
        </div>

        <div class="col col-right">

            <div class="project-location-map-container">
                &nbsp;
            </div>

            <div *ngIf="locationHasValidMap === false" class="grid-connection-address-map-container no-map">
                <i class="dx-icon dx-icon-map"></i> <b i18n="@@noLocation">No location</b>
            </div>

            <iframe *ngIf="locationHasValidMap === true" class="grid-connection-address-map-container"
                [src]="locationMapURL | safeResourceURL">
            </iframe>

            <div style="display:flex;flex-direction:row;height:100%;width: 100%;">
                <div style="display:flex;flex-direction:column;width: 100%" *ngIf="pvAnlageVisible">
                    <div *ngIf="locations != undefined || locations != null" class="col-right-lower">
                        <div class="location-grid-container full-height">
                            <div class="tabpanel-demo">
                                <div class="widget-container">

                                    <div class="gt-secondary-nav-tab-container ">
                                        <div *ngFor="let locationType of locationTypes" class="gt-secondary-nav-tab"
                                            i18n-innerText [innerText]="locationType.locationTypeName"
                                            (click)="selectedIndexChanged(locationType.locationTypeId)"
                                            [ngClass]="{'secondary-nav-tab-active-selected': selectedIndex === (locationType.locationTypeId ), 'status-green': selectedIndex !== (locationType.locationTypeId )}">
                                        </div>
                                    </div>
                                    <dx-data-grid #tabgrid [showBorders]="false" [dataSource]="locationsFiltered"
                                        showRowLines="true" height="'80vh'"
                                        class="gt-data-grid-style" rowAlternationEnabled="true"
                                        [hoverStateEnabled]="true"
                                        [editing]="{ mode: 'form', texts: { saveRowChanges: 'CONFIRM', cancelRowChanges: 'CANCEL' } }"
                                        (onSelectionChanged)="jumpToLocation($event)" [allowColumnResizing]="true"
                                        [columnResizingMode]="'widget'" [columnAutoWidth]="false" [showBorders]="true"
                                        [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'">
                                        <dxo-selection mode="single"> </dxo-selection>
                                        <dxi-column dataField="address" i18n-caption="@@address"
                                            caption="Address"></dxi-column>
                                        <dxi-column dataField="city" i18n-caption="@@city" caption="City"></dxi-column>
                                        <dxi-column dataField="postalCode" i18n-caption="@@postalCode"
                                            caption="Postal Code"></dxi-column>

                                        <dxi-column dataField="country" i18n-caption="@@country"
                                            caption="Country"></dxi-column>

                                        <dxi-column dataField="state" i18n-caption="@@stateProvince"
                                            caption="State/Province"></dxi-column>

                                        <dxi-column dataField="longitude" i18n-caption="@@logitude" caption="Longitude"
                                            [visible]="false"></dxi-column>
                                        <dxi-column dataField="latitude" i18n-caption="@@latitude" caption="Latitude"
                                            [visible]="false"></dxi-column>
                                        <dxi-column dataField="notes" i18n-caption="@@notes"
                                            caption="Notes"></dxi-column>
                                        <dxi-column [visible]="editMode" cellTemplate="buttonCellTemplate" width="68px"
                                            [formItem]="{visible: false}">
                                        </dxi-column>
                                        <div *dxTemplate="let item of 'buttonCellTemplate'">
                                            <div class="cell-with-buttons">
                                                <div class="cell-button-container">
                                                    <app-gpd-button icon="edit" type="text"
                                                        (onClick)="editLocation(item.data, item.rowIndex)">
                                                    </app-gpd-button>
                                                    <app-gpd-button icon="delete" type="danger"
                                                        (onClick)="initDeleteLocation(item.data, item.rowIndex)">
                                                    </app-gpd-button>
                                                </div>
                                            </div>
                                        </div>
                                    </dx-data-grid>
                                    <app-gpd-button *ngIf="userCanEdit" [disabled]="!editMode"
                                        type="text"
                                        i18n-text="@@addAddress" text="ADD ADDRESS" (onClick)="addLocation()" icon="add">
                                    </app-gpd-button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!pvAnlageVisible">3</div>

            </div>
        </div>
    </div>
</div>
<div class="project-bottom-page-button-container">
    <div class="gt-flex" style="gap: 8px">
        <app-gpd-button *ngIf="editMode" type="secondary" (onClick)="cancelEditMode()"
            i18n-text="@@cancel" text="CANCEL" icon="cancel"></app-gpd-button>
        <app-gpd-button *ngIf="editMode && userCanDeleteSite" type="danger"
            (onClick)="initDeleteSite()" i18n-text="@@delete" text="DELETE SITE" icon="delete"></app-gpd-button>
        <!-- <dx-button *ngIf="!editMode" class="gt-button gt-tertiary gt-btn-right" (onClick)="goTo('grid-connections')"
            i18n-text="@@backCaps" text="BACK"></dx-button> -->
    </div>
    <div class="gt-flex">
        <app-gpd-button *ngIf="editMode" (onClick)="saveSiteData()"
            i18n-text="@@save" text="SAVE" icon="check"></app-gpd-button>
        <app-gpd-button *ngIf="!editMode && userCanEdit" type="secondary"
            (onClick)="enableEditMode()" i18n-text="@@edit" text="EDIT" icon="edit"></app-gpd-button>
    </div>
</div>


<!-- <app-delete-popup (onConfirm)="handleDelete($event)" (onAbort)="onDeleteAbort($event)"  [visible]="deletePopupVisible" i18n-message message="Do you want to delete this Address?"></app-delete-popup> -->

<dx-popup dragEnabled="true" resizeEnabled="true" [visible]="editAddressVisible" i18n-title title="{{addressPopUp}}"
    (onHiding)="editAddressVisible = false && addAddressVisible = false; resetForm()" [width]="800" height="auto">

    <form action="none" (submit)="saveSiteLocation($event)">

        <dx-form validationGroup="addLocationValidaton" [formData]="selectedLocation" [colCount]="2">

            <dxi-item editorType="dxTextBox" [colSpan]="2" dataField="address" [editorOptions]="{maxLength: 100}">
                <dxo-label i18n-text="@@address" text="Address"></dxo-label>
                <dxi-validation-rule type="required" i18n-message message="Address is required">
                </dxi-validation-rule>
            </dxi-item>
            <dxi-item editorType="dxTextBox" [colSpan]="1" dataField="city" [editorOptions]="{maxLength: 50}">
                <dxo-label i18n-text="@@city" text="City"></dxo-label>
            </dxi-item>
            <dxi-item editorType="dxTextBox" [colSpan]="1" dataField="postalCode" [editorOptions]="{maxLength: 10}">
                <dxo-label i18n-text="@@postalCode" text="Postal Code"></dxo-label>
                <dxi-validation-rule type="stringLength" [max]="10" i18n-message="@@max10"
                    message="Maximum length is 10"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dxo-label i18n-text="@@country" text="Country"></dxo-label>
                <dxi-validation-rule type="required" i18n-message message="required">
                </dxi-validation-rule>
                <div *dxTemplate="'statesTempalte'">
                    <dx-select-box [(value)]="selectedLocation.countryId" [dataSource]="countriesByLanguageList"
                        (onSelectionChanged)="handleCountryChange(selectedLocation.countryId)" displayExpr='countryName'
                        valueExpr='countryId' acceptCustomValue="false">
                    </dx-select-box>
                </div>
            </dxi-item>
            <dxi-item dataField="stateId" [colSpan]="1" editorType="dxSelectBox"
                [editorOptions]="{ dataSource: statesByLanguageList,  displayExpr:'stateName', valueExpr:'stateId',  acceptCustomValue: false  }">
                <dxo-label i18n-text="@@federalState" text="State/Province"></dxo-label>
                <dxi-validation-rule type="required" i18n-message message="State is required">
                </dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="1" dataField="latitude" [editorOptions]="{maxLength: 50, max: 90, min: -90}">
                <dxo-label i18n-text="@@latitude" text="Latitude"></dxo-label>
                <!-- <dxi-validation-rule type="numeric" i18n-message message="Invalid Latitude">
                            </dxi-validation-rule> -->
                <dxi-validation-rule type="range" i18n-message message="Invalid Latitude" [min]="-90"
                    [max]="90"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="1" dataField="longitude" [editorOptions]="{maxLength: 50}" [validationRules]="
                {}">
                <dxo-label i18n-text="@@longitude" text="Longitude"></dxo-label>
                <!-- <dxi-validation-rule type="numeric" i18n-message message="Invalid Longitude">
                </dxi-validation-rule> -->
                <dxi-validation-rule type="range" i18n-message message="Invalid Longitude" [min]="-180"
                    [max]="180"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="2" dataField="notes" editorType="dxTextBox">
                <dxo-label i18n-text="@@notes" text="Notes"></dxo-label>
            </dxi-item>

            <!-- <dxi-item [colSpan]="2">
                <div *dxTemplate="'saveAddressButtonTempalte'">
                    <dx-button i18n-text="@@saveAddressCaps" text="SAVE ADDRESS" class="gt-button gt-primary gt-btn-right" (onClick)="saveSiteLocation()"></dx-button>
                </div>
            </dxi-item> -->

            <dxi-item itemType="button" [colSpan]="2" horizontalAlignment="center" [buttonOptions]="
            {
            width:'200px',
            text: saveAddressText,
            icon: 'key',
            type: 'success',
            stylingMode: 'contained',
            useSubmitBehavior: true
            }">
            </dxi-item>

        </dx-form>
    </form>


</dx-popup>

<dx-toast [(visible)]="toastVisible" i18n-message="@@savedSuccessfully" message="Saved successfully"></dx-toast>
<dx-toast [visible]="toastTwoVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>

<app-delete-popup [visible]="deletePopupVisible" i18n-message message="Do you want to delete this Location?"
    (onConfirm)="handleDelete($event)" (onAbort)="deletePopupVisible = false"></app-delete-popup>


<!--##############################-->
<!--Remove Site/Project-->

<app-delete-popup [visible]="deleteSitePopupVisible" i18n-message message="Do you want to delete this Site?"
    (onConfirm)="handleDeleteSiteShowFolders($event)" (onAbort)="deleteSitePopupVisible = false"></app-delete-popup>

<dx-popup dragEnabled="true" resizeEnabled="true" height="auto" width="600px"
    [(visible)]="deleteSiteFolderPopupVisible">
    <div>
        <p [innerHTML]="removeSiteFolderMessage"> </p>
    </div>
    <div class="gt-bottom-page-button-container">
        <div class="gt-flex-width">
            <dx-button i18n-text text="Remove Folders/Files" class="gt-button gt-tertiary gt-bottom gt-btn-left"
                (onClick)="handleRemoveSiteFolders()">
            </dx-button>
        </div>
        <div class="gt-flex-dir-row-rev">
            <dx-button i18n-text text="Keep Folders/Files" class="gt-button gt-primary gt-bottom gt-btn-right"
                (onClick)="handleKeepSiteFolders()">
            </dx-button>
        </div>
    </div>
</dx-popup>

<app-delete-popup [visible]="deleteProjectPopupVisible" i18n-message message="Do you want to delete this Project?"
    (onConfirm)="handleDeleteProjectShowFolders($event)"
    (onAbort)="deleteProjectPopupVisible = false"></app-delete-popup>

<dx-popup dragEnabled="true" resizeEnabled="true" height="auto" width="600px"
    [(visible)]="deleteProjectFolderPopupVisible">
    <div>
        <p [innerHTML]="removeProjectFolderMessage"> </p>
    </div>
    <div class="gt-bottom-page-button-container">
        <div class="gt-flex-width">
            <dx-button i18n-text text="Remove Folders/Files" class="gt-button gt-tertiary gt-bottom gt-btn-left"
                (onClick)="handleRemoveProjectFolders()">
            </dx-button>
        </div>
        <div class="gt-flex-dir-row-rev">
            <dx-button i18n-text text="Keep Folders/Files" class="gt-button gt-primary gt-bottom gt-btn-right"
                (onClick)="handleKeepProjectFolders()">
            </dx-button>
        </div>
    </div>
</dx-popup>
